import {
  CUSTOM_SIZE_MAX,
  CUSTOM_SIZE_MIN,
  ExportFormat,
  ResizeMode,
  type ExportOptions,
} from '@/core/export/types'

export const JPEG_QUALITY_MIN = 0.6
export const JPEG_QUALITY_MAX = 1
export const JPEG_QUALITY_ERROR_MESSAGE = `JPEG quality must be a finite number from ${JPEG_QUALITY_MIN} to ${JPEG_QUALITY_MAX}`

export function assertJpegQuality(jpegQuality: number): void {
  if (!Number.isFinite(jpegQuality) || jpegQuality < JPEG_QUALITY_MIN || jpegQuality > JPEG_QUALITY_MAX) {
    throw new Error(JPEG_QUALITY_ERROR_MESSAGE)
  }
}

export function validateExportOptions(options: ExportOptions): void {
  if (!Object.values(ExportFormat).includes(options.format)) {
    throw new Error(`Invalid export format: "${String(options.format)}"`)
  }
  if (!Object.values(ResizeMode).includes(options.resizeMode)) {
    throw new Error(`Invalid resize mode: "${String(options.resizeMode)}"`)
  }
  assertJpegQuality(options.jpegQuality)
  if (options.resizeMode === ResizeMode.Custom) {
    const customLongestSide = options.customLongestSide
    if (customLongestSide === null || !Number.isInteger(customLongestSide)
      || customLongestSide < CUSTOM_SIZE_MIN
      || customLongestSide > CUSTOM_SIZE_MAX) {
      throw new Error(`Custom export longest side must be an integer from ${CUSTOM_SIZE_MIN} to ${CUSTOM_SIZE_MAX}`)
    }
  } else if (options.customLongestSide !== null) {
    throw new Error('Custom export longest side must be null unless Custom size is selected')
  }
}
